export default __webpack_public_path__ + "static/media/mastercard.b34187b3.svg";